import React, { useState } from 'react'
import Form from 'react-bootstrap/Form'

// Disambiguation picker for a select/multiselect/mcc_select filter whose term matched multiple
// close options. The backend returns the candidate {value,label} list; the user picks the intended
// option(s), reported upward as the chosen values. `select` is single-choice; multiselect/mcc_select
// allow multiple. Mirrors the ReferenceResolver pattern used for vendor/employee references.
const OptionResolver = ({ resolution, onChange }) => {
  const { accessor_key: accessorKey, display_name: displayName, filter_type: filterType, search_term: searchTerm, candidates = [] } = resolution
  const isSingle = filterType === 'select'
  const [selected, setSelected] = useState([])

  const toggle = (value) => {
    const next = isSingle
      ? [value]
      : (selected.includes(value) ? selected.filter((v) => v !== value) : [...selected, value])
    setSelected(next)
    onChange(next)
  }

  return (
    <div className="border rounded-3 p-2 mt-2" style={{ backgroundColor: '#fff' }}>
      <div className="text-muted mb-1" style={{ fontSize: '0.72rem' }}>
        {displayName} — multiple options match “{searchTerm}”. Pick {isSingle ? 'the one' : 'the option(s)'} you mean:
      </div>
      <div className="d-flex flex-column gap-1" style={{ maxHeight: 160, overflowY: 'auto' }}>
        {candidates.map((c) => (
          <Form.Check
            key={c.value}
            type={isSingle ? 'radio' : 'checkbox'}
            name={`opt-${accessorKey}-${searchTerm}`}
            id={`opt-${accessorKey}-${c.value}`}
            checked={selected.includes(c.value)}
            onChange={() => toggle(c.value)}
            label={<span style={{ fontSize: '0.82rem' }}>{c.label}</span>}
          />
        ))}
      </div>
    </div>
  )
}

export default OptionResolver
